import { Box, Typography } from "@mui/material";

export default function ProductPanel({ productData, productColorMap, onMetricClick }) {
  const total = productData.reduce((s, d) => s + d.count, 0);

  const styles = {
    panel: {
      bgcolor: "background.cardBackground",
      border: 1,
      borderColor: "background.tableHeader",
      borderRadius: 2,
      p: 2.5,
      minWidth: 0,
      overflow: "hidden",
    },
    title: {
      fontSize: "0.75rem",
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      fontWeight: 700,
      color: "background.textMuted",
      mb: 2,
    },
    stackedBar: {
      height: 10,
      borderRadius: 1.25,
      overflow: "hidden",
      display: "flex",
      mb: 2,
    },
    rows: {
      display: "flex",
      flexDirection: "column",
      gap: 1.125,
    },
    row: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      cursor: "pointer",
      borderRadius: 0.5,
      "&:hover": { bgcolor: "action.hover" },
    },
    swatch: {
      width: 8,
      height: 8,
      borderRadius: 0.25,
      flexShrink: 0,
    },
    rowLabel: {
      flex: 1,
      minWidth: 0,
      fontSize: "0.875rem",
      color: "background.text",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    rowCount: {
      fontSize: "0.9375rem",
      fontWeight: 700,
      color: "background.text",
      fontVariantNumeric: "tabular-nums",
      minWidth: 14,
      textAlign: "right",
    },
    rowPct: {
      fontSize: "0.75rem",
      color: "background.textMuted",
      minWidth: 32,
      textAlign: "right",
      fontVariantNumeric: "tabular-nums",
    },
  };

  return (
    <Box sx={styles.panel}>
      <Typography sx={styles.title}>By Product</Typography>
      <Box sx={styles.stackedBar}>
        {productData.map(({ product, count }) => {
          const color = productColorMap[product] || "primary.main";
          const segSx = {
            width: `${(count / total) * 100}%`,
            height: "100%",
            bgcolor: color,
          };
          return <Box key={product} sx={segSx} />;
        })}
      </Box>
      <Box sx={styles.rows}>
        {productData.map(({ product, count }) => {
          const color = productColorMap[product] || "primary.main";
          const swatchSx = { ...styles.swatch, bgcolor: color };
          const pct = Math.round((count / total) * 100);
          return (
            <Box key={product} sx={styles.row} onClick={() => onMetricClick("product", product)}>
              <Box sx={swatchSx} />
              <Typography sx={styles.rowLabel}>{product}</Typography>
              <Typography sx={styles.rowCount}>{count}</Typography>
              <Typography sx={styles.rowPct}>{pct}%</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
